export default __webpack_public_path__ + "static/Benefits_PoolHealth_HD_411x192-fa65a6f2f231d36e20705d053cf76514.png";